import {parseDateData, removeDuplicateLogs} from '../utils';
export default function common(state={}, action) {
	switch (action.type) {
		case 'INIT':
			var logs = state.loginLog.concat(parseDateData(action.data['login_history'],true));
			logs.sort(function(a,b){return (new Date(b.date).getTime()) - (new Date(a.date).getTime())});
			return {
				...state,
				userInfo: action.data['user_info'],
				loginLog: removeDuplicateLogs(logs),
				sensitiveOps: parseDateData(action.data['sensitive_operation'],false),
				gameOtpConfigs: action.data['game_otp_configs']
			};
		case 'UPDATE_USER_SUSPICIOUS':
			return {
				...state,
				userInfo: {
					...state.userInfo,
					suspicious: action.data['suspicous']
				}
			};
		case 'FETCH_LOGS':
			if(action.data['login_history'].length>0){
				var new_logs = state.loginLog.concat(parseDateData(action.data['login_history'].slice(1),true));
				new_logs.sort(function(a,b){return (new Date(b.date).getTime()) - (new Date(a.date).getTime())});
				return {
					...state,
					loginLog: removeDuplicateLogs(new_logs),
					last_login_ts: action.data['last_login_ts'],
					last_im_ts: action.data['last_im_ts']
				}
			}
			break;

		case 'UPDATE_EMAIL':
			return {
				...state,
				userInfo: {
					...state.userInfo,
					email: action.data
				}
			};
		case 'CHANGE_LANGUAGE':{
			localStorage.setItem('lang',action.data.name);
			return {
				...state,
				language: action.data
			};
		}


		default:
			return state;
	}
}


// WEBPACK FOOTER //
// ./app/reducers/common.js